import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import type { Tables } from '$/database.types';

export type AdminOrgContext = Pick<
  Tables<'strategic_contexts'>,
  'id' | 'org_id' | 'sector' | 'strategic_orientation' | 'operating_constraints' | 'metadata' | 'created_at'
>;

async function fetchAdminOrgContext(orgId: string): Promise<AdminOrgContext | null> {
  const { data, error } = await supabaseClient.functions.invoke('admin-org-context', {
    method: 'POST',
    body: { org_id: orgId },
  });

  if (error) throw new Error(error.message ?? 'Failed to fetch context');
  return (data?.data ?? null) as AdminOrgContext | null;
}

const useAdminOrgContext = (orgId: string | null | undefined) =>
  useQuery({
    queryKey: ['admin-org-context', orgId],
    queryFn: () => fetchAdminOrgContext(orgId!),
    enabled: !!orgId,
  });

export default useAdminOrgContext;
